import React from 'react';

import Battery from '@/features/timeGame/components/elements/Battery';

import WarpTubeBottomSvg from '@/features/timeGame/assets/images/warp-tube-bottom.svg?react';
import WarpTubeGlassSvg from '@/features/timeGame/assets/images/warp-tube-glass.svg?react';
import WarpTubeTopSvg from '@/features/timeGame/assets/images/warp-tube-top.svg?react';

import '@/features/timeGame/styles/warp-tube.scss';

interface Props {
	batteryLevel: number; // 0-5 battery level
	children?: React.ReactNode;
	isBatteryTooltipOpen?: boolean;
}

const WarpTube = ({ batteryLevel, isBatteryTooltipOpen = false }: Props) => {
	return (
		<div className="warp-tube">
			<div className="warp-tube__top">
				<WarpTubeTopSvg className="warp-tube__top-svg" />
				<Battery level={batteryLevel} isTooltipOpen={isBatteryTooltipOpen} />
			</div>

			<div className="warp-tube__glass">
				<WarpTubeGlassSvg className="warp-tube__glass-svg" />
			</div>

			<div className="warp-tube__bottom">
				<WarpTubeBottomSvg className="warp-tube__bottom-svg" />
			</div>
		</div>
	);
};

export default WarpTube;
